import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { injectIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import { functionalities, privileges } from '@/shared/services/AuthService';

import messages from './deviationOverviewMessages';

const DeviationOverviewGlobalActionsButton = ({ intl, disabled, onUpdateExecutionDuration }) => (
  <span
    className="tool-tip"
    data-toggle="tooltip"
    data-placement="top"
    title={disabled ? intl.formatMessage(messages.NoRowsSelected) : ''}
  >
    <DropdownButton
      bsSize="small"
      bsStyle="default"
      className="btn-inverse"
      id="deviation-overview-global-actions-button"
      disabled={disabled}
      pullRight
      title={intl.formatMessage(messages.GlobalActions)}
    >
      <MenuItemWithSecurity
        onSelect={onUpdateExecutionDuration}
        functionality={functionalities.CapacityPlanning}
        privilege={privileges.Update}
      >
        {intl.formatMessage(messages.UpdateExecutionDuration)}
      </MenuItemWithSecurity>
    </DropdownButton>
  </span>
);

DeviationOverviewGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onUpdateExecutionDuration: PropTypes.func.isRequired,
};

DeviationOverviewGlobalActionsButton.defaultProps = { disabled: false };

export default injectIntl(DeviationOverviewGlobalActionsButton);
